import { useCallback, useState } from 'react';
import { useFeatureFlags } from '@funtech-int/yango-shared';

import { PlayingState } from '@/scenarios/legacy-player/types/instance';

import { checkInterval } from '../../SessionStop.config';

import { useRepeatableCallback } from './use-repeatable-callback';
import { useActionOnStart } from './useActionOnStart';

interface SessionState {
    startedTime: number | null;
    isStopped: boolean;
}

const PAUSE_AFTER = 14400;

export const useSessionStopped = (playingState?: PlayingState) => {
    const [sessionState, setSessionState] = useState<SessionState>({
        startedTime: null,
        isStopped: false,
    });

    const start = useCallback(() => {
        setSessionState({ startedTime: Date.now(), isStopped: false });
    }, []);

    const { restart } = useActionOnStart(start);

    const sessionStopPauseAfter = useFeatureFlags().flags.get(
        'sessionStopPauseAfter',
        'number',
        PAUSE_AFTER
    );

    const check = useCallback(() => {
        if (
            sessionState.startedTime !== null &&
            Date.now() - sessionState.startedTime > sessionStopPauseAfter * 1000 &&
            playingState &&
            [PlayingState.buffering, PlayingState.play].includes(playingState)
        ) {
            setSessionState({ startedTime: null, isStopped: true });
        }
    }, [playingState, sessionState.startedTime, sessionStopPauseAfter]);

    useRepeatableCallback(check, checkInterval);

    return { sessionStopped: sessionState.isStopped, reset: restart };
};
